import React from "react";
import ReactECharts from "echarts-for-react";
import dayjs from "dayjs";
import "dayjs/locale/fr";

// Associe les codes aux couleurs
const colorMapping = {
  0: "#DFFFF9",
  1: "#D4EA62",
  2: "#F4C842",
  3: "#F0907F",
};

const CalendarHistorique = ({ data }) => {
  // Regroupe les données par mois
  const groupedData = data.reduce((acc, [date, code]) => {
    const month = date.slice(0, 7); // Ex: "2025-01"
    if (!acc[month]) acc[month] = [];
    acc[month].push({ date, code });
    return acc;
  }, {});

  const allMonths = Object.keys(groupedData);
  const today = ''//'2020-05-13'

  return (
    <div>
      <div
        style={{
          display: "grid",
          // gridTemplateColumns: "repeat(3, 1fr)",
          gap: "20px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {allMonths.map((month) => {
          const dates = groupedData[month] || [];
          const formattedData = dates.map(({ date, code }) => ({
            value: [date, 1],
            itemStyle: { color: colorMapping[code] },
          }));
          const scatterData = dates.map(({ date }) => ({
            value: [date, 1],
            label: {
              show: true,
              formatter: () => dayjs(date).format("D"),
              color: date === today ? "#C61616" : "#000", // Rouge si c'est aujourd'hui, sinon noir
              fontSize: date === today ? 55 : 40, // Taille 25 si c'est aujourd'hui, sinon 20
              fontWeight: date === today ? "bold" : "normal", // Gras si c'est aujourd'hui
            },
          }));

          const option = {
            title: {
              text: `${dayjs(month).locale("fr").format("MMMM YYYY")}`,
              left: "center",
              top:0,
              textStyle: { fontSize: 40, fontWeight: "bold", color:'#C61616' },
            },
            visualMap: { show: false },
            calendar: {
              top: 150,
              left: "center",
              cellSize: ["auto", 110],
              monthLabel: { show: false },
              yearLabel: { show: false },
              range: month,
              orient: "vertical",
              itemStyle: { borderWidth: 1 },
              dayLabel: {
                firstDay: 1,
                nameMap: ["D", "L", "M", "M", "J", "V", "S"],
                textStyle: { fontSize:35}
              },
            },
            series: [
              { type: "heatmap", coordinateSystem: "calendar", data: formattedData },
              { type: "scatter", coordinateSystem: "calendar", symbolSize: 1, data: scatterData },
            ],
          };

          return (
            <div key={month} style={{ width: "98%", marginBottom: "20px" }}>
              <ReactECharts option={option} style={{ height: 820 }} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarHistorique;
